<div *ngIf="isLoading == true || showNotice == false" class="row h-100 justify-content-center align-items-center">
  <div class="text-center">
    <app-loading-spinner></app-loading-spinner>
  </div>
</div>
<div class="h-100 blueBackground" [hidden]="isLoading == true" *ngIf="showNotice == true && cmsModule == true">
  <div class="row mx-0 p-0 mt-4 mb-4 justify-content-center align-items-center blueBackground">
    <div class="card HRegular Form blueBackground" style="margin-top: 40px; margin-bottom: 17px; max-width: 840px;">
      <div *ngFor="let row of cmsRows; let rowIndex = index">
        <div class="one-column pointer" *ngIf="row.component1?.size == 2" (click)="execute(row.component1)">
          <div class="container" *ngIf="globalService.isRTL == true"><img [src]="row.component1?.imageURL" />
            <h1 class="largeArabic" [class.lightArabic]="row.component1.color == 1"
              [class.darkArabic]="row.component1.color == 2"
              [ngClass]="{'top': row.component1?.position == 1, 'middle': row.component1?.position == 2, 'bottom': row.component1?.position == 3}">
              {{ getTitle(row.component1) }}</h1>
          </div>
          <div class="container" *ngIf="globalService.isRTL == false"><img [src]="row.component1?.imageURL" />
            <h1 class="large" [class.light]="row.component1.color == 1" [class.dark]="row.component1.color == 2"
              [ngClass]="{'top': row.component1?.position == 1, 'middle': row.component1?.position == 2, 'bottom': row.component1?.position == 3}">
              {{ getTitle(row.component1) }}</h1>
          </div>
        </div> 
        <div class="two-columns pointer" *ngIf="row.component1?.size == 1">
          <div class="container" *ngIf="row.component1 != null && globalService.isRTL == true"
            (click)="execute(row.component1)"><img [src]="row.component1?.imageURL" />
            <h1 class="smallArabic" [class.lightArabic]="row.component1.color == 1"
              [class.darkArabic]="row.component1.color == 2"
              [ngClass]="{'top': row.component1?.position == 1, 'middle': row.component1?.position == 2, 'bottom': row.component1?.position == 3}">
              {{ getTitle(row.component1) }}</h1>
          </div>
          <div class="container" *ngIf="row.component1 != null && globalService.isRTL == false"
            (click)="execute(row.component1)"><img [src]="row.component1?.imageURL" />
            <h1 class="small" [class.light]="row.component1.color == 1" [class.dark]="row.component1.color == 2"
              [ngClass]="{'top': row.component1?.position == 1, 'middle': row.component1?.position == 2, 'bottom': row.component1?.position == 3}">
              {{ getTitle(row.component1) }}</h1>
          </div>
          <div class="container" *ngIf="row.component2 != null && globalService.isRTL == true"
            (click)="execute(row.component2)"><img [src]="row.component2?.imageURL" />
            <h1 class="smallArabic" [class.lightArabic]="row.component2.color == 1"
              [class.darkArabic]="row.component2.color == 2"
              [ngClass]="{'top': row.component2?.position == 1, 'middle': row.component2?.position == 2, 'bottom': row.component2?.position == 3}">
              {{ getTitle(row.component2) }}</h1>
          </div> 
          <div class="container" *ngIf="row.component2 != null && globalService.isRTL == false"
            (click)="execute(row.component2)"><img [src]="row.component2?.imageURL" />
            <h1 class="small" [class.light]="row.component2.color == 1" [class.dark]="row.component2.color == 2"
              [ngClass]="{'top': row.component2?.position == 1, 'middle': row.component2?.position == 2, 'bottom': row.component2?.position == 3}">
              {{ getTitle(row.component2) }}</h1> 
          </div>
        </div>
      </div>
      <div class="row" *ngIf="user != null && identityService.hasCMSAdministrator()">
        <div class="row mt-3 mx-4" style="display: none;">
          <div class="form-group col-12">
            <label class="form-check-label text-center" [class.mr-4]="globalService.isRTL == true">{{
              globalService.Get("AGREE_CONTENT") }} <br/>
              <input type="checkbox" class="form-check-input" [checked]="agreementAccepted"
              (click)="AcceptAgreement($event.target.checked)" />
              <a class="mx-2" href="https://church-services.com/terms-of-use/" target='self'>{{
                globalService.Get("REVIEW_TERMS_HERE")
                }} </a></label>
          </div>
        </div> 
        <div class="col-12">
          <button class="btn btn-success btn-block largeButton mt-2 mb-2" type="button" (click)="openConfigure()">
            <div [class.ArabicFont]="globalService.isRTL == true">
              {{ globalService.Get("CONFIGURE") }}
            </div>
          </button>
        </div>
      </div>
      <div style="display: none;" class="row" *ngIf="user == null || (user != null && identityService.hasCMSAdministrator() == false)">
        <div class="col-12 mt-2 text-center">
          <span><small>To report abuse related to this app please email: <br> nashwa.abualsaad&#64;church-services.org</small></span>
        </div>
      </div>      
    </div>
  </div>
  <div class="container h-100" [hidden]="isLoading == true" *ngIf="showNotice == true && cmsModule == false">
    <div class="row justify-content-center align-items-center mt-5">
      <div class="card RegularForm rounded col-12 col-xs-9 col-lg-8"
        [class.SmallArabicFont]="globalService.isRTL == true">
        <div class="card-body MyCardBody rounded-bottom" [hidden]="isLoading">
          <app-dupes (dupeLoadingComplete)="OnDupeLoadingComplete()" (dupesComplete)="OnDupesComplete()"></app-dupes>
          <app-invitations (inviteLoadingComplete)="OnInviteLoadingComplete()"
            (invitesComplete)="OnInvitesComplete()"></app-invitations>
        </div>
      </div>
    </div>
  </div>  
</div> 